import DatePicker from "react-datepicker";
import moment from "moment";

// import "react-datepicker/dist/react-datepicker.css";

const Calendar = ({date, handleDateChange, ctaTitle, ctaTextarea, showCalendar}) => {

	// const [startDate, setStartDate] = useState(new Date());

	return (
		<div className="calendar">
			<div className={`calendar__container ${showCalendar}`}>
				<DatePicker
					open={true}
					selected={date && moment(date).toDate()}
					onChange={(date) => handleDateChange(date)}
					disabledKeyboardNavigation
				/>
			</div>
			{ctaTitle && ctaTextarea && (
				<div className="cta">
					<h4 dangerouslySetInnerHTML={{__html: ctaTitle}} />
					<p dangerouslySetInnerHTML={{__html: ctaTextarea}} />
				</div>
			)}
		</div>
	);
};

export default Calendar;
